module.exports = __webpack_public_path__ + "img/usecargobranco.bcb207b2.png";